<template>
  <v-select
    v-if="!isLoading"
    v-model="clase.equipaje_cabina.peso"
    :items="pesos"
    item-text="name"
    item-value="id"
    outlined
    dense
    hide-details
    :suffix="sufijo"
    disabled
    @change="changeSelect()"
  ></v-select>
</template>

<script>

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    clase: {
      type: Object,
    },
  },
  data() {
    return {
      isLoading: true,
      sufijo: null,
      pesos: [],
    }
  },

  created() {
    this.load()
  },
  methods: {

    load() {
      this.axios.get(`nom_peso_equipaje_flights?perfil_slug=${sessionStorage.getItem('perfil')}&tipo=cabina`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('sanctum_auth')}`,
        },
      })
        .then(res => {
          const result = res.data.data
          result.forEach(element => {
            if (element.tipo === 'Equipaje de mano') {
              this.pesos.push({
                id: element.id,
                name: `${element.name}`,
              })
            }
          })
        })
        // eslint-disable-next-line no-return-assign
        .finally(() => (this.isLoading = false))
    },
    changeSelect() {
      this.sufijo = null
      if (this.clase.equipaje_cabina.peso) {
        this.sufijo = this.pesos.filter(e => e.id === this.clase.equipaje_cabina.peso)[0].um
      }
    },
  },
}
</script>
